import React from "react";
import ContatosSplit from "../../components/ContactSplit";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ImportantNews from "../../components/ImportantNews";
import { HomeProductions } from "../../components/HomeProductions";

export default function Home({ siteContent }) {
  const { social, title, information } = siteContent;
  return (
    <>
      <section className="hero" aria-label="Destaque">
        <div className="hero__bg" />
        <div className="container hero__content">
          <div className="hero__card">
            <h1 className="hero__title">{title}</h1>
            <Link className="btn btn--primary" to={"quem-somos"}>
              SAIBA MAIS
            </Link>
          </div>
        </div>
      </section>

      <main className="container main">
        <ImportantNews siteContent={information} />
        <HomeProductions siteContent={siteContent} />
        <section className="section">
          <h2 className="section__title">CONTATOS</h2>
          <ContatosSplit siteContent={social} />
        </section>
      </main>
    </>
  );
}
